function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change',
    cartError: 'cart-error',
};

let subscribers = {};

function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
    }

    subscribers[eventName] = [...subscribers[eventName], callback];

    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
            return cb !== callback;
        });
    };
}

function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
            callback(data);
        });
    }
}

class BulkAdd extends HTMLElement {
    constructor() {
        super();
        this.queue = [];
        this.requestStarted = false;
        this.ids = [];
    }

    startQueue(id, quantity) {
        this.queue.push({ id, quantity });
        const interval = setInterval(() => {
            if (this.queue.length > 0) {
                if (!this.requestStarted) {
                    this.sendRequest(this.queue);
                }
            } else {
                clearInterval(interval);
            }
        }, 250);
    }

    sendRequest(queue) {
        this.requestStarted = true;
        const items = {};
        queue.forEach((queueItem) => {
            items[parseInt(queueItem.id)] = queueItem.quantity;
        });
        this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
        const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
        quickBulkElement.updateMultipleQty(items);
    }

    resetQuantityInput(id) {
        const input = this.querySelector(`#Quantity-${id}`);
        input.value = input.getAttribute('value');
        this.isEnterPressed = false;
    }

    setValidity(event, index, message) {
        event.target.setCustomValidity(message);
        event.target.reportValidity();
        this.resetQuantityInput(index);
        event.target.select();
    }

    validateQuantity(event) {
        const inputValue = parseInt(event.target.value);
        const index = event.target.dataset.index;

        if (inputValue < event.target.dataset.min) {
            this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
        } else if (inputValue > parseInt(event.target.max)) {
            this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
        } else if (inputValue % parseInt(event.target.step) != 0) {
            this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
        } else {
            event.target.setCustomValidity('');
            event.target.reportValidity();
            this.startQueue(index, inputValue);
        }
    }

    getSectionsUrl() {
        if (window.pageNumber) {
            return `${window.location.pathname}?page=${window.pageNumber}`;
        } else {
            return `${window.location.pathname}`;
        }
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
}

if (!customElements.get('bulk-add')) {
    customElements.define('bulk-add', BulkAdd);
}


/* ====================================================================
   Shopify Search Tracking & URL Clean Handler
   1. On Product Page: Removes search parameters (_pos, _sid, _ss, _fid)
      from the address bar via replaceState once tracking has initialized.
   2. On Search Results / Hover: Keeps link preview URLs clean when
      hovered, while attaching tracking parameters on user interaction
      (pointerdown/click/Enter) so Shopify tracking continues working.
   ==================================================================== */
(function() {
    var trackingParams = ['_pos', '_sid', '_ss', '_fid'];

    // Part 1: Clean Address Bar on Product / Destination Pages
    function removeSearchTrackingParams() {
        if (!window.location.search) return;
        try {
            var url = new URL(window.location.href);
            var params = url.searchParams;
            var hasTracking = false;

            trackingParams.forEach(function(param) {
                if (params.has(param)) {
                    params.delete(param);
                    hasTracking = true;
                }
            });

            if (hasTracking) {
                var cleanSearch = params.toString() ? ('?' + params.toString()) : '';
                var cleanUrl = url.pathname + cleanSearch + url.hash;
                window.history.replaceState(window.history.state, document.title, cleanUrl);
            }
        } catch (e) {
            // Graceful fallback
        }
    }

    if (document.readyState === 'complete') {
        setTimeout(removeSearchTrackingParams, 0);
    } else {
        var hasCleaned = false;
        var runClean = function() {
            if (!hasCleaned) {
                hasCleaned = true;
                removeSearchTrackingParams();
            }
        };

        window.addEventListener('load', runClean);
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(runClean, 1500);
        });
    }

    // Part 2: Clean Hover URLs on Search Page / Predictive Search
    function cleanSearchLinks(root) {
        var context = root || document;
        var links = context.querySelectorAll('a[href*="_pos="], a[href*="_sid="], a[href*="_ss="]');
        links.forEach(function(link) {
            try {
                var url = new URL(link.href, window.location.origin);
                var params = url.searchParams;
                var extracted = [];

                trackingParams.forEach(function(param) {
                    if (params.has(param)) {
                        extracted.push(param + '=' + encodeURIComponent(params.get(param)));
                        params.delete(param);
                    }
                });

                if (extracted.length > 0) {
                    link.setAttribute('data-search-tracking', extracted.join('&'));
                    var cleanSearch = params.toString() ? ('?' + params.toString()) : '';
                    link.href = url.origin + url.pathname + cleanSearch + url.hash;
                }
            } catch (e) {}
        });
    }

    // Restore tracking parameter when user clicks / interacts with the link
    function restoreTrackingOnInteraction(e) {
        var link = e.target && e.target.closest ? e.target.closest('a[data-search-tracking]') : null;
        if (link) {
            var tracking = link.getAttribute('data-search-tracking');
            if (tracking && !link.search.includes('_pos=')) {
                var separator = link.href.includes('?') ? '&' : '?';
                link.href = link.href + separator + tracking;
            }
        }
    }

    // Attach tracking on pointerdown (mouse click, touch) or Enter key
    document.addEventListener('pointerdown', restoreTrackingOnInteraction, true);
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
            restoreTrackingOnInteraction(e);
        }
    }, true);

    // Initial clean on DOM ready and window load
    if (document.readyState !== 'loading') {
        cleanSearchLinks();
    } else {
        document.addEventListener('DOMContentLoaded', function() {
            cleanSearchLinks();
        });
    }
    window.addEventListener('load', function() {
        cleanSearchLinks();
    });

    // Observe dynamically added search results (e.g. predictive search or AJAX filters)
    if (typeof MutationObserver !== 'undefined') {
        var observerTimeout;
        var observer = new MutationObserver(function() {
            clearTimeout(observerTimeout);
            observerTimeout = setTimeout(function() {
                cleanSearchLinks();
            }, 100);
        });
        if (document.body) {
            observer.observe(document.body, { childList: true, subtree: true });
        } else {
            document.addEventListener('DOMContentLoaded', function() {
                observer.observe(document.body, { childList: true, subtree: true });
            });
        }
    }
})();
